import React from 'react';
import PropTypes from 'prop-types';
import { H2 } from 'components/core/Typography';
import { Container } from 'components/core/Page';
import { SizeChip } from 'components/molecules/SizeChip';
import './SizeGuideHero.scss';
import { MarkdownWrapper } from 'components/atoms';

const SizeGuideHero = ({ subtitle, title, description, chips, activeChip }) => (
	<header className="size-guide-hero">
		<Container>
			<div className="size-guide-hero__content">
				<h1 className="size-guide-hero__subtitle">{subtitle}</h1>
				<H2
					size="medium"
					color="white"
					className="size-guide-hero__title"
				>
					{title}
				</H2>
				<div className="size-guide-hero__description">
					{description.map((p, i) => (
						<MarkdownWrapper
							key={`description-${i}`}
							content={[{ value: p }]}
							componentProps={{ color: 'white' }}
						/>
					))}
				</div>
				<div className="size-guide-hero__chips">
					{chips.map((chip) => (
						<SizeChip
							key={chip.label}
							label={chip.label}
							url={chip.url}
							isActive={activeChip === chip.label}
						/>
					))}
				</div>
			</div>
		</Container>
	</header>
);

SizeGuideHero.propTypes = {
	subtitle: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.arrayOf(PropTypes.string).isRequired,
	chips: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
		}),
	).isRequired,
	activeChip: PropTypes.string,
};

SizeGuideHero.defaultProps = {
	activeChip: null,
};

export default SizeGuideHero;
